<template>
  <section>
    <VerDetalle />
    <!-- Componentes externos -->
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Comisión Viajes
    </h3>
    <v-card>
      <v-card-text>
        <v-tooltip bottom>
          <v-btn
            v-if="!filterShow"
            class="btn-refresh"
            icon
            slot="activator"
            @click="
              v => {
                filterShow = true;
              }
            "
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
          <span>Filtros</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            v-if="filterShow"
            class="btn-refresh"
            icon
            slot="activator"
            @click="
              v => {
                filterShow = false;
              }
            "
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
          <span>Ocultar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            @click.native="cargaListado()"
            class="btn-refresh"
            slot="activator"
            ><v-icon>refresh</v-icon>
          </v-btn>
          <span>{{ $t("common.updateList") }}</span>
        </v-tooltip>
        <v-layout row wrap>
          <v-layout row wrap v-if="filterShow">
            <v-flex xs2>
              <v-text-field
                append-icon="search"
                label="Nombres"
                single-line
                hide-details
                @input="filterNombres"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                append-icon="search"
                label="Cite"
                single-line
                hide-details
                @input="filterCite"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                append-icon="search"
                label="Fecha salida"
                single-line
                hide-details
                @input="filterSalida"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                append-icon="search"
                label="Fecha retorno"
                single-line
                hide-details
                @input="filterRetorno"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-flex xs4>
            <v-select
              :items="authors"
              label="Author"
              @change="filterAuthor"
            ></v-select>
          </v-flex> -->

          <v-flex>
            <v-data-table
              :headers="headers"
              :items="rows"
              item-key="cite"
              :search="filters"
              :custom-filter="customFilter"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>

              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-center">{{ props.item.nombres }}</td>
                  <td class="text-xs-center">{{ props.item.cite }}</td>
                  <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                  <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>
                  <td class="nowrap text-xs-center">
                    <v-tooltip bottom>
                      <v-btn
                        color="green"
                        icon
                        slot="activator"
                        @click.prevent="verDetalleViaje(props.item)"
                      >
                        <v-icon>visibility</v-icon>
                      </v-btn>
                      <span>Ver registro</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerDetalle from "./dialogs/VerDetalle"; // Componente de creación y actualización

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      filters: {
        nombres: "",
        cite: "",
        fecha_desde: "",
        fecha_hasta: "",
        added_by: ""
      },
      authors: ["Admin", "Editor"],
      headers: [
        { text: "Nombres", align: "center", value: "nombres", sortable: false },
        { text: "Cite", value: "cite", align: "center" },
        { text: "Fecha salida", value: "fecha_desde", align: "center" },
        { text: "Fecha retorno", value: "fecha_hasta", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      rows: [],
      filterShow: true,
      ci: -1
    };
  },
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.ci = this.$route.params.ci;
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    await this.cargaListado();
  },
  // Métodos y funciones del componente
  methods: {
    verDetalleViaje(item) {
      item.ci=this.ci
      this.$bus.$emit("openDialogVerDetalle", item);
    },
    async cargaListado() {
      // SELECT * FROM CONTROL.fn_datos_viajes_sipav('4791999'::varchar)
      // AS datos(
      //   nombres,
      //   cite,
      //   objetivo,
      //   lugar,
      //   fecha_desde,
      //   fecha_hasta,
      //   hora_salida,
      //   hora_llegada,dias)
  
      let respuesta;
      let consulta = `SELECT * FROM CONTROL.fn_datos_viajes_sipav('${this.ci}'::varchar) AS datos(nombres,cite,objetivo,lugar,fecha_desde,fecha_hasta,hora_salida,hora_llegada,dias)`;
      try {
         console.log(`
						query{
						runQuery(consulta:"${consulta}"){
							respuesta
						}
						}
						`)
        respuesta = await this.$service.graphql({
          query: `
						query{
						runQuery(consulta:"${consulta}"){
							respuesta
						}
						}
						`
        });
        console.log("tam:",respuesta.runQuery.respuesta.length)
        if (respuesta.runQuery.respuesta.length>0) {
          //console.log("+++++",respuesta.runQuery.respuesta)
        respuesta = respuesta.runQuery.respuesta;
        for (let index = 0; index < respuesta.length; index++) {
          const element = respuesta[index];
          element.fecha_desde = element.fecha_desde
            .split("-")
            .reverse()
            .join("/");
          element.fecha_hasta = element.fecha_hasta
            .split("-")
            .reverse()
            .join("/");
        }
        this.rows = respuesta;
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    getPersonaId() {
      return parseInt(this.$route.params.id_persona);
    },
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter("nombres", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.nombres.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("cite", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.cite.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("fecha_desde", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.fecha_desde
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("fecha_hasta", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          return item.fecha_hasta
            .toLowerCase()
            .includes(searchWord.toLowerCase());
        }, searchWord);
      });
      cf.registerFilter("added_by", function(added_by, items) {
        if (added_by.trim() === "") return items;
        return items.filter(item => {
          return item.added_by.toLowerCase() === added_by.toLowerCase();
        }, added_by);
      });
      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters();
    },
    filterNombres(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nombres: val
      });
    },
    filterCite(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        cite: val
      });
    },
    filterSalida(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        fecha_desde: val
      });
    },
    filterRetorno(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        fecha_hasta: val
      });
    },
    filterAuthor(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        added_by: val
      });
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    VerDetalle
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/comision_viaje/ListadoViajeDetalleConsulta.vue